import { HTTP } from '../../utils'

export const getTagSettings = (institutionId) => {
  return HTTP().get('/tagSetting/institution/setting?uuid=' + institutionId + '&count=' + 200)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const createOrUpdateTagSetting = (data) => {
  var url = '/tagSetting'
  if (data.uuid) {
    url += '/' + data.uuid
  }
  return HTTP().put(url, data)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteMultipleTagSettings = (uuids) => {
  return HTTP().delete('/tagSetting/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCategorisedTags = (uuid, entityType) => {
  return HTTP().get('/tagSetting/institution/' + uuid + '/' + entityType + '/categorisedTags')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const updateAppliedTagMap = (data) => {
  var url = '/'
  var suffix = '/updateWithAppliedTagsAndLearningObjectives/'
  if (data.type === 'stream') {
    url += 'entity' + suffix
  } else if (data.type === 'catalog') {
    url += 'catalog' + suffix
  } else if (data.type === 'course') {
    url += 'deliverycontext' + suffix
  } else if (data.type === 'topics') {
    url += 'topic' + suffix
  } else if (data.type === 'assets') {
    url += 'learningcontent' + suffix
  } else if (data.type === 'job') {
    url += 'job' + suffix
  } else if (data.type === 'club') {
    url += 'club' + suffix
  } else if (data.type === 'event') {
    url += 'event' + suffix
  } else if (data.type === 'person') {
    url += 'person' + suffix
  }
  url += data.uuid
  return HTTP().put(url, {'tags': data.appliedTagMap, 'careerCompetenciesMap': data.careerCompetenciesMap, 'careerCompetenciesList': data.careerCompetenciesList})
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteTagsFromEntity = (url, categoryToBeDeleted) => {
  return HTTP().put(url, categoryToBeDeleted)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCompetencySkillTypes = (source) => {
  return HTTP().get('/competency/skills/' + source + '/types')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCompetencySkillsBasedOnTypes = (types, keyword, page) => {
  let url = '/competency/skills/filtered?types=' + types + '&page=' + page
  if (keyword) {
    url += '&startWith=' + keyword
  }
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/tagging/api.js